export const HubspotFormConstants = {
    CONTACT_MODAL_FORM_ID: process.env.REACT_APP_HUBSPOT_CONTACT_FORM_ID ?? "",
    REASON_FIELD_NAME: "reason_for_reaching_out",
    REASON_IS_MODIFY: "Modify my subscription",
    REASON_IS_ENTERPRISE_RENEWAL: "Renew Enterprise Subscription",
};
